/**
 * Validate that at least two of the three form fields are populated.
 *
 * @returns Boolean.
 */
export default function hasEnoughPopulatedFields(): boolean {
  const selectors = [
    'input#order_number',
    'input#serial_number',
    'input#postcode',
  ];
  let count = 0;
  for (const selector of selectors) {
    const elem = document.querySelector(selector) as HTMLInputElement;
    if (elem?.value) {
      count = count + 1;
    }
  }

  return count < 2 ? false : true;
}
